module.exports = __webpack_public_path__ + "static/media/sandwich.cce248a7.png";